<template>
  <div ref="form">
    <attributes v-if="platform === 'shopify'" />
    <div>
      <tabs v-if="printAreas.length > 1">
        <tab
          v-for="(printArea, index) in printAreas"
          :key="index"
          :title="printArea.name"
        >
          <artwork-form
            :artwork="printArea.artwork"
            @error="error => onError(errors[printArea.artwork.id], error)"
          />
        </tab>
      </tabs>
      <template v-else>
        <artwork-form
          v-if="printAreas.length === 1"
          :value="printAreas"
          :artwork="printAreas[0].artwork"
          @error="error => onError(printAreas[0].artwork.id, error)"
        />
      </template>
      <button ref="btn_show_preview" v-bind:class="{previewLoad: previewLoad}" :disabled='previewLoad' class="btn btn-default btn-preview" @click="showPreview">
        {{textButtonPreview}}
      </button>
      <div class="btn-preview-fixed-box" :class="{'active': btn_show_preview_fixed_show}">
        <button
          ref="btn_show_preview_fixed"
          v-bind:class="{previewLoad: previewLoad}"
          :disabled='previewLoad'
          class="btn btn-default btn-preview-fixed" @click="showPreview">
          {{textButtonPreview}}
        </button>
      </div>

      <div class="add-to-cart-wrapper">
        <input type="number" min="1" class="form-control" v-model="qty" />
        <button
          :disabled="hasError()"
          class="btn btn-primary btn-add-to-cart"
          @click="addToCart"
        >
          <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading" />
          Add to Cart
        </button>
      </div>
      <div v-if="activeBundled" class="bundled-products">
        <bundled-products />
      </div>
    </div>
    <modal
      name="showPreview"
      :adaptive="true"
      height="auto"
      width="700px"
      :max-width="800"
      :min-width="320"
      :reset="true"
      style="max-width:100%"
      class="HdevPreviewOmcustome"
    >
      <div class="preview-container-om__header">
        <span class="preview-container-om__btn-close" @click="$modal.hide('showPreview')">
          <font-awesome-icon icon="times" style="color:#ffffffe0" />
        </span>
      </div>

      <div class="preview-container-om" style="position:relative">

        <div class="preview-container-om_notice">
          <p class="preview-container-om--title">Please check the preview carefully</p>
          <p class="preview-container-om_content">
            <em>Make sure the customization is correct to receive your item faster</em>
          </p>
        </div>
        <!-- <Preview />
        <Preview /> -->
        <Preview />

        <button
          @click="addToCart"
          class="preview-add-to-cart">
          <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading" /> Add To Cart
        </button>
      </div>
    </modal>
    <div class="loading_add_to_cart_single" v-if="loading">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      <div class="message-text-loading">Loading, please wait...</div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import LayerFormItem from './Form/LayerFormItem'
import { get, cloneDeep, forEach } from 'lodash'
import ArtworkForm from './ArtworkForm'
import Attributes from './Form/Attributes'
import jQuery from 'jquery'
import Loading from './Utilities/Loading'
import Tabs from './Form/Tabs'
import Tab from './Form/Tab'
import BundledProducts from './BundledProducts'
import Preview from './Preview'
import { uploadFromBase64, filterObject, getSignedUrl, prepareCanvasForCapture } from '@/helper/helper'
import { ASSET_URL, ACTIVE_BUNDLED_PRODUCT } from '@/config.js'
import {treeToArray} from '../helper/helper'

export default {
  props: {
    shopifyForm: {
      type: Object,
      default: null
    },
    addToCartText: {
      type: String
    },
    addCartButton: {
      type: Object
    },
    originProductID: {
      type: String,
      default: ''
    }
  },
  components: {
    LayerFormItem,
    ArtworkForm,
    loading: Loading,
    Attributes,
    Tabs,
    Tab,
    Preview,
    BundledProducts
  },
  data() {
    return {
      template: 0,
      errors: {},
      customization: {},
      printAreas: [],
      qty: 1,
      loading: false,
      previewLoad: false,
      textButtonPreview: "Preview Your Customize",
      activeBundled: false,
      btn_show_preview_fixed_show: false
    }
  },
  created() {
    jQuery(window).on('updateVariant', () => {
      var variantEl = jQuery('[name=id]')
      if (variantEl.length > 0) {
        this.setSelectedVariant(jQuery('[name=id]').val())
      }
    })

    if(ACTIVE_BUNDLED_PRODUCT){
      this.activeBundled = true
    }else{
      this.activeBundled = false
    }
    if (window.innerWidth <= 768) {
      window.addEventListener('scroll', (e) => this.handleCheckShowPreviewScroll(e));
      this.btn_show_preview_fixed_show = true;
    }
  },
  mounted() {
    const { platform } = this
    if (platform === 'shopify') {
      this.setSelectedVariant(jQuery('[name=id]').val())
      if (!this.selectedVariant) {
        this.setSelectedVariant(this.product.variants[0].id)
      }
      const { selectedVariant } = this
      if (selectedVariant) {
        const { variantMockups } = this
        var vm = variantMockups.find(
          v => v.originVariantID === selectedVariant.toString()
        )
        this.variantMockup = vm
      }
    } else {
      jQuery('[name=variation_id]').on('change', function() {
        jQuery(this).trigger('x-change')
      })
      this.setSelectedVariant(jQuery('[name=variation_id]').val() || 419319)
      jQuery('[name=variation_id]').on('x-change', e => {
        this.setSelectedVariant(e.target.value)
      })
      setInterval(() => jQuery('[name=variation_id]').trigger('x-change'), 1000)
    }
    this.customization = cloneDeep(this.personalized)
  },
  computed: {
    ...mapGetters([
      'product',
      'platform',
      'artworks',
      'mockups',
      'selectedArtworkID',
      'personalized',
      'selectedVariant',
      'variantMockups',
      'artworkPreviews',
      'ratios',
      'settings',
      'variants',
      'imageLoadings'
    ]),
    showVariantSelector() {
      return jQuery('[name=id]').length === 0
    }
  },
  watch: {
    selectedVariant(selectedVariant) {
      if (selectedVariant) {
        const { variants, artworks, variantMockups } = this
        var v = variants.find(v => v.origin_id === selectedVariant.toString())
        if (v) {
          this.printAreas = v.print_areas.map(p => {
            return {
              ...p,
              artwork: artworks.find(art => art.id === p.artwork_id)
            }
          })
        }
        var vm = variantMockups.find(
          v => v.originVariantID === selectedVariant.toString()
        )
        this.variantMockup = vm
      }
    },
    customization: {
      handler(customization) {
        forEach(customization, (data, artworkID) => {
          this.setPersonalized({ artworkID, data })
        })
      },
      deep: true
    },
    personalized: {
      handler(val) {
        const OnThis = this
        this.setLoadingMedia(true);
        OnThis.textButtonPreview = "Preview Your Customize...";
        OnThis.previewLoad = true;
        // Save to localstorage
        localStorage.setItem ('data_personalized', JSON.stringify(val) );
        // console.log(JSON.parse(localStorage.getItem('data_personalized')))
        if (this.shopifyForm) {
          this.shopifyForm
            .find(`[name='properties[_omcustom]']`)
            .val(JSON.stringify(val))
        }
        setTimeout(function (){
          OnThis.setLoadingMedia(false)
          OnThis.textButtonPreview = "Preview Your Customize";
          OnThis.previewLoad = false;
        }, 1000)
      },
      deep: true
    },
    error(error) {
      if (error) {
        document.querySelectorAll('button').forEach(b => (b.disabled = true))
      } else {
        document.querySelectorAll('button').forEach(b => (b.disabled = false))
      }
    },
    qty(qty) {
      // const { platform } = this
      this.setFormValue('quantity', qty)
      // var shopifyForm = jQuery(`form[action^='/cart/add']`)
      // if (shopifyForm.length) {
      //   if (shopifyForm.find(`[name=quantity]`).length === 0) {
      //     shopifyForm.append('<input type="hidden" name="quantity"/>')
      //   }
      //   shopifyForm.find(`[name=quantity]`).val(qty)
      // }
    },
  formValues(data) {
    // console.log(this.artworks[0].id)
    this.setPersonalized({ artworkID: this.artworks[0].id, data })
  }
  },
  methods: {
    ...mapMutations([
      'setSelectedArtworkID',
      'setPersonalized',
      'setSelectedVariant',
      'setLoadingMedia'
    ]),
    isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    handleCheckShowPreviewScroll(e){
      const checkDiv = this.$refs.btn_show_preview;
      this.btn_show_preview_fixed_show = !this.isElementInViewport(checkDiv);
    },
    showPreview(e) {
      e.preventDefault()
      this.$modal.show('showPreview')
    },
    async addToCart(e) {
      e.preventDefault()
      // console.log(this.$store.getters.getCartData);
      const { platform, variants, selectedVariant } = this
      this.loading = true
      // add Cut Face
      const checkLayers = treeToArray(get(this.artworks[0], 'templates[0].layers', {}));
      if(checkLayers.length > 0){
        let getPersonalized = this.personalized[this.artworks[0].id];
        checkLayers.forEach(e => {
          const configCut = getPersonalized[e.id];
          if(typeof configCut == 'object'){
            const props = [
              'rotation','scaleX', 'scaleY', 'skewX', 'skewY', 'x', 'y', 'ratio'
            ];
            props.forEach((key)=> {
              if(e[key]){
                configCut[key] = e[key];
              }
            });
          }
        });
        this.setPersonalized({ artworkID: this.artworks[0].id, getPersonalized });
      }
      // end
      var addToCartForm =
        platform === 'woocommerce'
          ? jQuery(this.$refs.form).closest('form')
          : jQuery(`form[action^='/cart/add']`)
      if (addToCartForm.length) {
        // Chờ font tải xong + vẽ lại canvas trước khi chụp preview gửi khách.
        await prepareCanvasForCapture()
        // Get order thumbnail
        // console.log(addToCartForm)
        var orderImagePreview = null
        jQuery('#om-product-carousels [variant-ids]').each((_, el) => {
          var variantIds = jQuery(el)
            .attr('variant-ids')
            .split(',')
          if (variantIds.includes(`${selectedVariant}`)) {
            if (jQuery(el).find('canvas').length === 1) {
              orderImagePreview = jQuery(el)
                .find('canvas')[0]
                .toDataURL()
            }
            return false
          }
        })
        if (!orderImagePreview) {
          // Get first render mockup
          jQuery('#om-product-carousels [is-render=1]').each((_, el) => {
            if (jQuery(el).find('canvas').length === 1) {
              orderImagePreview = jQuery(el)
                .find('canvas')[0]
                .toDataURL()
              return false
            }
          })
        }
        if (orderImagePreview) {
          var preview = await uploadFromBase64(orderImagePreview, 'image/png')
          this.setFormValue('properties[_preview]', preview.key)
        }
        // Upload custom images
        var customData = filterObject(this.personalized, [
          'created_at',
          'updated_at',
          'deleted_at',
          'user_id',
          'file_mime',
          'file_name',
          'file_size',
          'source'
        ])
        await Promise.all(
          Object.keys(customData).map(artwork_id => {
            return Promise.all(
              Object.keys(customData[artwork_id]).map(layer_id => {
                if (
                  customData[artwork_id][layer_id] &&
                  customData[artwork_id][layer_id].base64
                ) {
                  return new Promise((resolve, reject) => {
                    uploadFromBase64(
                      customData[artwork_id][layer_id].base64,
                      'image/jpeg'
                    )
                      .then(file => {
                        customData[artwork_id][layer_id].key = file.key
                        delete customData[artwork_id][layer_id].base64
                        resolve(1)
                      })
                      .catch(err => reject(err))
                  })
                } else {
                  return Promise.resolve(1)
                }
              })
            )
          })
        ).catch(err => err)
        //Generate download printFile URL
        var variant = variants.find(
          v => v.origin_id === selectedVariant.toString()
        )

        // console.log(customData);
        // return;

        var printFiles = await Promise.all(
          Object.keys(customData).map(artwork_id => {
            return getSignedUrl('image/png', 1).then(res => {
              return Promise.resolve({
                artwork_id,
                print_area: variant.print_areas.find(
                  printArea => printArea.artwork_id === artwork_id
                ).name,
                url: `${ASSET_URL}/${res.key}`, // res.url,
                key: res.key
              })
            })
          })
        )
        this.setFormValue(
          'properties[_print_files]',
          JSON.stringify(printFiles)
        )
        this.setFormValue(
          'properties[_root_data]',
          JSON.stringify(this.$store.getters.getCartData)
        )
        const bundledProducts = this.$store.state.bundledProducts;
        if(bundledProducts.length >= 1){
          this.setFormValue('properties[_bundled_products]', JSON.stringify(bundledProducts))
        }
        var form = this.setFormValue(
          'properties[_omcustom]',
          JSON.stringify(customData)
        )

        form.submit()
        this.loading = false
      }
    },
    hasError() {
      const { errors } = this
      for (let artworkID in errors) {
        if (errors[artworkID]) {
          return true
        }
      }
      return false
    },
    onError(artworkID, err) {
      this.errors = { ...this.errors, [artworkID]: err }
    },
    setFormValue(name, value) {
      const { platform } = this
      var addToCartForm =
        platform === 'woocommerce'
          ? jQuery(this.$refs.form).closest('form')
          : jQuery(`form[action^='/cart/add']`)
      if (addToCartForm.length) {
        var customEl = addToCartForm.find(`input[name='${name}']`)
        if (customEl.length === 0) {
          customEl = jQuery(`<input name="${name}" type="hidden"/>`)
          addToCartForm.append(customEl)
        }
        customEl.val(value)
      }
      return addToCartForm
    }
  }
}
</script>
<style scoped>
.message-text-loading {
  color: #444444;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}
.btn-add-to-cart {
  display: block;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.btn-preview {
  display: block;
  width: 100%;
  border: 1px solid #999;
}
.modal-close {
  position: absolute;
  top: 5px;
  right: 5px;
  border: 1px solid #ff7875;
  width: 30px;
  height: 30px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
}
</style>

<style>
.preview-container-om__header {
  padding: 10px 10px;
  display: flex;
  justify-content: end;

  position: absolute;
    top: 0px;
    z-index: 9999;
    right: 10px;
}
.preview-container-om__btn-close{
  height: 40px;
  width: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #ffffff00;
  border: none;
  /* border-radius: 50%; */
  /* border: 2px solid #ffffffe0; */
  border-radius: 50%;
  border: 2px solid #b4060081;

}

.preview-container-om__btn-close *{
  color: #b40600;
}

.preview-add-to-cart {
  margin: auto;
  display: block;
  background: #26bf31;
  color: #fff;
  border: none;
  padding: 0px 10px;
  border-radius: 5px;
  text-transform: uppercase;
  margin: 5px auto;
  margin-top: 15px;
  width: 246px;
  max-width: 100%;
  height: 48px;
  font-size: 16px;
  font-family: system-ui;
  font-weight: 600;
}

.HdevPreviewOmcustome.vm--container {
    z-index: 99999999999999 !important;
}


.HdevPreviewOmcustome .vm--modal::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

.HdevPreviewOmcustome .vm--modal::-webkit-scrollbar
{
  border-radius: 10px;
	width: 0px;
  height: 0px;
	background-color: #F5F5F5;
}

.HdevPreviewOmcustome .vm--modal::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #c4c4c4;
}

.preview-container-om{
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  overflow: auto;
  margin: 0px 10px;
  /* max-height: 80vh; */
}

.preview-container-om_notice {
  text-align: center;
}

.preview-container-om--title {
  margin: 5px;
  font-size: 18px;
  font-family: system-ui;
  font-weight: 700;
  line-height: 26px;
  margin-top: 10px;
}

.preview-container-om_content {
  font-weight: 400;
  margin: 0px;
  font-size: 16px;
  margin-bottom: 15px;
  line-height: 20px;
  color: #212529;
  font-family: system-ui;
}

.HdevPreviewOmcustome {
    z-index: 999999999 !important;
}

.HdevPreviewOmcustome .vm--modal{
  overflow: auto !important;
  background: none;
  border-radius: 10px;
  z-index: 99999 !important;
}

.btn-preview-fixed-box{
  position: fixed;
  bottom: 0;
  background: #fff;
  left: 0;
  right: 0;
  padding: 10px;
  z-index: 1000 !important;
  display: none;
}

.btn.btn-default.btn-preview-fixed {
  display: block;
  background: #d26e4b;
  color: #fff;
  border: none;
  padding: 0px 0px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: 500;
  margin-top: 0px;
  width: 100%;
  font-size: 16px;
  transition: opacity 0.5s ease, visibility 0.5s ease;
  margin: 0px !important;
  height: 48px;
}

@media (min-width: 1024px) {

  .HdevPreviewOmcustome img {
    width: 100%;
    height: 100%;
}

}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px){
  .HdevPreviewOmcustome .vm--modal {
    width: 100vw !important;
    background: none;
  }
  .preview-add-to-cart {
    width: 100%;
    margin-top: 15px;
    /* padding: 10px 20px; */
    /* border-radius: 10px; */
  }
  .preview-container-om{
    margin: 0px 10px;
    margin-bottom: 10px;
  }
  .btn-preview-fixed-box.active{
    display: block;
    animation: fadeInUp 0.6s ease-in-out;
  }
  .preview-container-om_content {
    font-size: 14px;
  }
  .preview-container-om__header {
    position: relative;
    right: 0;
  }
  .preview-container-om__btn-close{
    border: 2px solid #ffffffe0;
  }

  .preview-container-om__btn-close *{
    color: #ffffff !important;
  }
}

#om-product-mockups{
  position: relative;
}

.message-loading-group {
  display: none;
  position: absolute !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
  transition: 0.5s;
}

.message-loading-group.active{
  display: block;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.previewLoad {
    pointer-events: none;
    background: #00000029;
    color: #ffffff;
}

.bundled-products{
  display: flex !important;
}

.loading_add_to_cart_single {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffffcf;
    /*pointer-events: none;*/
    z-index: 99999999999 !important;
    cursor: not-allowed;
    flex-direction: column;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid rgb(129, 129, 129);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: rgb(38, 191, 49) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Form.vue